<template>
  <aside class="app-sidebar">
    <el-menu
      :collapse="getMenuCollapse"
      width="200"
      :unique-opened="true"
      :collapse-transition="false"
    >
      <NavMenu :navMenus="filteredMenuList"></NavMenu>
<!--      <template v-for="(item, index) in filteredMenuList">-->
<!--        &lt;!&ndash; 无子菜单 &ndash;&gt;-->
<!--        <el-menu-item-->
<!--          v-if="!item.children"-->
<!--          :index="'main-' + index"-->
<!--          :key="index"-->
<!--          @click="goPage(item)"-->
<!--        >-->
<!--          <base-icon :iconClass="item.icon"></base-icon>-->
<!--          <span slot="title">{{ $t(`router.${item.name}`) }}</span>-->
<!--        </el-menu-item>-->

<!--        &lt;!&ndash; 有子菜单 &ndash;&gt;-->
<!--        <el-submenu-->
<!--          v-if="item.children && item.children.length>0"-->
<!--          :index="'main-' + index"-->
<!--          :key="index"-->
<!--        >-->
<!--          <template slot="title" @click="goPage(subItem)">-->
<!--            <base-icon :iconClass="item.icon"></base-icon>-->
<!--            <span slot="title">{{ $t(`router.${item.name}`) }}</span>-->
<!--          </template>-->

<!--          <el-menu-item-->
<!--            v-for="(subItem, subIndex) in item.children"-->
<!--            :index="`sub-${index}-${subIndex}`"-->
<!--            :key="`${index}-${subIndex}`"-->
<!--            @click="goPage(subItem)"-->
<!--            class="app-sidebar__item"-->
<!--          >-->
<!--            &lt;!&ndash; <base-icon :iconClass="subItem.icon"></base-icon> &ndash;&gt;-->
<!--            <span slot="title">{{ item.isI18n?subItem.name:$t(`router.${subItem.name}`) }}</span>-->
<!--          </el-menu-item>-->
<!--        </el-submenu>-->
<!--      </template>-->
    </el-menu>
    <div class="app-sidebar_bottom">
      <div v-if="!getMenuCollapse" class="app-sidebar_bottom__version">
        {{copyright}}<br>
        {{version}}
      </div>
      <div v-if="getMenuCollapse">
        <el-popover
          placement="top-start"
          width="200"
          trigger="click"
          popper-class="app-sidebar_bottom__popover">
          <div>
            {{copyright}}<br>
            {{version}}
          </div>
          <div class="app-sidebar_bottom__version__icon" slot="reference">&copy;</div>
        </el-popover>
      </div>
      <a href="JavaScript:;" class="collapse" @click="toggleCollapse">
        <div>
          <i :class="getMenuCollapse?'el-icon-d-arrow-right':'el-icon-d-arrow-left'"></i>
          <span v-if="!getMenuCollapse">{{$t('router.collapseSidebar')}}</span>
        </div>
      </a>
    </div>
  </aside>
</template>

<script>
import {
  mapState, mapActions, mapGetters, mapMutations,
} from 'vuex';
import NavMenu from './NavMenu';

export default {
  components: {
    NavMenu,
  },
  data() {
    return {
      layIndex: 0,
      activeIndex: 'aa',
    };
  },
  computed: {
    ...mapState('corporation', ['corporation']),
    ...mapGetters(['getMenuCollapse', 'getBreadcrumbItems']),
    ...mapGetters(['filteredMenuList']),
    version() {
      return this.$store.state.version;
    },
    copyright() {
      return (this.corporation && this.corporation.copyright) || '';
    },
  },
  created() {
    this.$store.dispatch('checkVersion');
  },
  watch: {
    filteredMenuList() {
     // console.log(this.filteredMenuList);
      if (this.filteredMenuList) {
        const mprojects = this.filteredMenuList.projects;
        if (mprojects) {
          if (mprojects.maxIndex) {
            const maxIndex = mprojects.maxIndex;
            console.log(maxIndex);
          }
        }
      }
    },
  },
  mounted() {
    window.addEventListener(
      'resize',
      () => {
        this.$bus.$emit('RESIZE_WINDOW');
      },
      false,
    );
    this.setCollapse({ isCollapse: !this.getMenuCollapse });
    setTimeout(() => {
      this.$bus.$emit('RESIZE_WINDOW');
    }, 50);
  },
  methods: {
    ...mapActions(['setCollapse']),
    ...mapMutations('project', ['SET_CURRENT_PROJECT']),
    toggleCollapse() {
      this.setCollapse({ isCollapse: !this.getMenuCollapse });
      setTimeout(() => {
        this.$bus.$emit('RESIZE_WINDOW');
      }, 50);
    },
    goPage(item) {
      if (item.type === 'function') {
        console.log('function');
        this.SET_CURRENT_PROJECT(item.project);
        // 发布项目发生改变的广播
        this.$bus.$emit('UPDATE_PROJECT', item.project.id);
        if (this.$route.meta && this.$route.meta.attachProject) {
          this.$router.replace({ path: this.$route.path });
          return;
        }
      }
      this.$router.push(item.path);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu {
  border-right: 0;
}
</style>
<style lang="scss">
@import "../../assets/theme/_themes.scss";
.el-menu--popup {
  background-color: #000000;
}
// .el-tooltip__popper.is-dark {
//   background-color: #000000;
// }
.app-sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  text-align: left;
  @include background_image("background-img-sider");
  background-size: cover;
  background-repeat: no-repeat;
  .el-menu-item,
  .el-submenu__title {
    height: 48px;
    line-height: 48px;
    position: relative;
    &:hover,
    &:focus {
      @include font_color("font-sider-hover");
      @include background_color(
      "background-color-sider",
      $type: "rgba",
      $alpha: 0.4
      );
    }
  }

  .el-menu-item.is-active{
    @include font_color("font-sider-hover");
    @include background_color(
      "background-color-sider",
      $type: "rgba",
      $alpha: 0.4
    );
  }

  .el-submenu.is-opened {
    @include background_color(
      "background-color-sider",
      $type: "rgba",
      $alpha: 0.4
    );
    &.is-active .el-submenu__title::after{
      position: absolute;
      left: 0;
      top:0;
      height:100%;
      content:'';
      border-left: 12px solid;
      @include border_color("font-sider-hover");
    }
    & > .el-menu {
      @include background_color(
        "background-color-sider",
        $type: "rgba",
        $alpha: 0.4
      );
      .el-menu-item.is-active {
        @include font_color("font-sider-hover");
        @include background_color("font-sider-hover", $type: "rgba", $alpha: 0.3);
        border-left: 0;
      }
    }
  }
  .el-menu {
    overflow-y: auto;
    overflow-x: hidden;
    background-color: transparent;
    &:not(.el-menu--collapse) {
      width: (200 + layIndex)px;
    }
    &.el-menu--collapse {
      width: 42px;
    }
    .el-menu-item.is-active::after{
      position: absolute;
      left: 0;
      top:0;
      height:100%;
      content:'';
      border-left: 2px solid;
      @include border_color("font-sider-hover");
    }
    .app-sidebar__item {
      padding: 0;
      list-style: disc inside;
      padding-left: 30px !important;
    }
    .base-icon {
      margin-right: 5px;
      width: 18px !important;
      height: 18px !important;
    }
  }

  .collapse {
    @include font_color('font-white');
    line-height: 40px;
    width: 100%;
    display: inline-block;
    box-sizing: content-box;
    height: 40px;
    &>div {
      padding: 0 20px;
    }
    i {
      font-size: 16px;
      font-weight: bold;
    }
  }
  &_bottom {
    width: 100%;
    &__version{
      @include font_color('font-white');
      font-size: 13px;
      padding: 10px 20px;
      line-height: 23px;
      max-width: 160px;
      &__icon {
        cursor: pointer;
        @include font_color('font-white');
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
      }
    }
    &__popover {
      @include background_color('background-color-box');
      @include font_color('font-nomarl');
      @include border_color('border-popper-color');
    }
  }
}

</style>
